import React from "react";
import { TextField } from "@material-ui/core";

export function InputWithMaskara(props) {
  const maskTel = (tel) => {
    tel = tel.replace(/\D/g, "");

    if (tel.length <= 10) {
      tel = tel.replace(/(\d{2})(\d)/, "$1 $2");
      tel = tel.replace(/(\d{4})(\d)/, "$1-$2");
    } else {
      tel = tel.replace(/(\d{2})(\d)/, "$1 $2");
      tel = tel.replace(/(\d{5})(\d)/, "$1-$2");
    }

    return tel.substring(0, 13);
  };

  const maskCpf = (doc) => {
    doc = doc.replace(/\D/g, "");

    doc = doc.replace(/(\d{3})(\d)/, "$1.$2");
    doc = doc.replace(/(\d{3})(\d)/, "$1.$2");
    doc = doc.replace(/(\d{3})(\d{1,2})$/, "$1-$2");

    return doc.substring(0, 14);
  };

  const maskCnpj = (doc) => {
    doc = doc.replace(/\D/g, "");

    doc = doc.replace(/^(\d{2})(\d)/, "$1.$2");
    doc = doc.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
    doc = doc.replace(/\.(\d{3})(\d)/, ".$1/$2");
    doc = doc.replace(/(\d{4})(\d)/, "$1-$2");

    return doc.substring(0, 18);
  };

  const maskara = () => {
    if (props.typesPix === "cpf") return maskCpf(props.change);

    if (props.typesPix === "cnpj") return maskCnpj(props.change);

    if (props.typesPix === "phone") return maskTel(props.change);
  };

  return (
    <TextField
      label={props.typesPix}
      variant="outlined"
      size="small"
      value={props.typesPix === "email" ? props.change : maskara(props.change)}
      onChange={props.onChange}
    />
  );
}
